import type { EvaluationModule } from '@bc-library/interface'

export const EVALUATION_SETTING_ACCESS_KEYS = [
  'settingsEvaluationFormsAccess',
  'settingsEvaluationAveragesAccess',
  'settingsEvaluationOfficesAccess',
] as const

export type EvaluationSettingAccessKey = typeof EVALUATION_SETTING_ACCESS_KEYS[number]

export const hasAnyEvaluationSettingsAccess = (evaluation?: EvaluationModule) => {
  if (!evaluation)
    return false
  if (evaluation.settingsAccess)
    return true
  if (EVALUATION_SETTING_ACCESS_KEYS.some(key => evaluation[key]))
    return true
  return !!evaluation.canEditEvaluation
}

export const hasEvaluationSettingAccess = (
  evaluation: EvaluationModule | undefined,
  key: EvaluationSettingAccessKey,
) => {
  if (!evaluation)
    return false
  if (evaluation.settingsAccess)
    return true
  if (!EVALUATION_SETTING_ACCESS_KEYS.some(k => evaluation[k]))
    return !!evaluation.canEditEvaluation
  return !!evaluation[key]
}
